module.exports = __webpack_public_path__ + "img/logo-icoev-actual.14beb646.png";